// extracted by mini-css-extract-plugin
module.exports = {"personalCenterWrapper":"personalCenterWrapper--A6ko2","switchAccountBtn":"switchAccountBtn--a+i8-"};